import { useReducer } from 'react';
import { produce } from 'immer';
import { DraftState } from '@/types';
import { DraftReducer } from '@/components/draft/draftState/types';
import { validateDraft } from '@/components/draft/draftState/validateDraft';

export const useDraft = (getInitialDraft: () => DraftState, reducer: DraftReducer) =>
  useReducer(reducer, undefined, () => {
    const draft = getInitialDraft();
    return produce(draft, (writableDraft: DraftState) => {
      validateDraft(writableDraft, { configurations: {} } as DraftState);
    });
  });
